const state = {
    sortingParameter: "",
    sortingType: "",
    filterParameter: "",
    searchParameter: "",
    secondFilterParameter: ""
};

const mutations = {
    SET_SORTING_PARAMETER(state, parameter) {
        state.sortingParameter = parameter
    },
    SET_SORTING_TYPE(state, type) {
        state.sortingType = type
    },
    SET_FILTER_PARAMETER(state, param) {
        state.filterParameter = param
    },
    SET_SEARCH_PARAMETER(state, param) {
        state.searchParameter = param
    },
    SET_SECOND_FILTER_PARAMETER(state, param) {
        state.secondFilterParameter = param
    }
};

const getters = {
    getSortingParameter: (state) => {
        return state.sortingParameter;
    },
    getSortingType: (state) => {
        return state.sortingType;
    },
    getFilterParameter: (state) => {
        return state.filterParameter;
    },
    getSearchParameter: (state) => {
        return state.searchParameter;
    },
    getSecondFilterParameter: (state) => {
        return state.secondFilterParameter
    }
};

export default {
    state,
    mutations,
    getters,
};
